import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiUtils.js';

const API_BASE_URL = getApiBaseUrl();

// Get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Create axios instance with auth header
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 401 handler
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      try {
        localStorage.removeItem('token');
      } catch (_e) {}
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);

export const contractorsApi = {
  // Get all contractors with optional filters
  getContractors: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.employment_type) {
        params.append('employment_type', filters.employment_type);
      }
      
      if (filters.is_active !== undefined) {
        params.append('is_active', filters.is_active.toString());
      }
      
      const response = await apiClient.get(`/contractors?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching contractors:', error);
      throw error;
    }
  },

  // Get contractor statistics
  getContractorStats: async () => {
    try {
      const response = await apiClient.get('/contractors/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching contractor stats:', error);
      throw error;
    }
  },

  // Get contractors by employment type
  getW2Employees: async () => {
    return contractorsApi.getContractors({ employment_type: 'w2' });
  },

  get1099Contractors: async () => {
    return contractorsApi.getContractors({ employment_type: '1099' });
  },

  getActiveContractors: async () => {
    return contractorsApi.getContractors({ is_active: true });
  },

  // Get all contractors for dashboard filtering
  getAllContractors: async () => {
    try {
      const response = await apiClient.get('/contractors/all');
      return response.data;
    } catch (error) {
      console.error('Error fetching all contractors:', error);
      throw error;
    }
  },
};

export default contractorsApi; 